






































import { Component, Inject, Vue } from 'vue-property-decorator'
import { User } from '@/api/model/user'
import { UserAPI } from '@/api/backend-client'
import { v4 as uuid } from 'uuid'
import { DashboardView, Gender, Role } from '@/api/types'

@Component
export default class CompanySettingsUsersCreate extends Vue {
    @Inject() readonly reloadCompany: () => Promise<void>
    user: User = null
    saving: boolean = false

    created(): void {
        this.user = User.fromData({
            company: this.$currentCompany,
            id: uuid(),
            firstname: null,
            middlename: null,
            lastname: null,
            avatar: null,
            avatarUrl: null,
            email: null,
            password: null,
            role: Role.EMPLOYEE,
            birthdate: null,
            gender: Gender.UNKNOWN,
            defaultDashboardView: DashboardView.USER,
            branches: [],
            betaOptInEnabled: true,
        })
    }

    async save(): Promise<void> {
        this.saving = true
        this.user = await UserAPI.create(this.user)
        await this.reloadCompany()
        this.saving = false
        await this.$router.push({ name: 'company_settings_users_list' })
    }

    async cancel(): Promise<void> {
        await this.$router.push({
            name: 'company_settings_users_list',
        })
    }
}
